import { alpha, useTheme } from "@mui/material"

interface SparklinePoint {
    date: string
    value: number
}

interface SparklineProps {
    points: SparklinePoint[]
    color: string
    width?: number
    height?: number
    label: string
}

/** Mini gráfico de tendência: trecho antigo esmaecido, último trecho (período atual) na cor de acento. */
const Sparkline = ({ points, color, width = 128, height = 32, label }: SparklineProps) => {
    const theme = useTheme() as any
    const ringColor = theme.palette.neutral.darkest

    if (points.length < 2) {
        return <svg width={width} height={height} aria-hidden="true" />
    }

    const values = points.map((p) => p.value)
    const min = Math.min(...values)
    const max = Math.max(...values)
    const span = max - min || 1
    const stepX = width / (points.length - 1)
    const pad = 4

    const coords = values.map((v, i) => [
        i * stepX,
        pad + (height - pad * 2) - ((v - min) / span) * (height - pad * 2),
    ])

    const toPolyline = (segment: number[][]) => segment.map(([x, y]) => `${x},${y}`).join(" ")

    const splitAt = Math.max(0, coords.length - 3)
    const dimSegment = coords.slice(0, splitAt + 1)
    const accentSegment = coords.slice(splitAt)
    const [endX, endY] = coords[coords.length - 1]

    return (
        <svg width={width} height={height} role="img" aria-label={`${label}: tendência recente`}>
            <polyline
                points={toPolyline(dimSegment)}
                fill="none"
                stroke={alpha(color, 0.35)}
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <polyline
                points={toPolyline(accentSegment)}
                fill="none"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle cx={endX} cy={endY} r={4} fill={color} stroke={ringColor} strokeWidth={2} />
        </svg>
    )
}

export { Sparkline }
export type { SparklinePoint }
